import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=08992c1f&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=08992c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08992c1f",
  null
  
)

export default component.exports